module.exports = __webpack_public_path__ + "img/9788968176296.83d77dc5.jpg";